import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.scss']
})
export class EnterpriseComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('Trinka 企業版 ｜團隊專用的寫作助理與文法檢查工具');
    this.metaTagService.updateTag({ name: 'description', content: '輕鬆將 Trinka 整合至您的企業工作流程，讓團隊全面掌握 Trinka 的強大功能。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '文法檢查工具，文法糾正，自動文法檢查，自動拼寫糾正，機構的學術寫作助手，出版商的學術寫作助手，語言服務提供者的學術寫作助手' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka 企業版 ｜團隊專用的寫作助理與文法檢查工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: '輕鬆將 Trinka 整合至您的企業工作流程，讓團隊全面掌握 Trinka 的強大功能。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise' });
  }

  globalSliderData: any[] = [
    { "imgSrc": "/assets/images/client_logos/j-j.png", "altText": "johnsons" },
    { "imgSrc": "/assets/images/client_logos/oxford.png", "altText": "oxford" },
    { "imgSrc": "/assets/images/client_logos/HarvardMedicalSchool.png", "altText": "Harvard Medical School" },
    { "imgSrc": "/assets/images/client_logos/merck.png", "altText": "merck" },
    { "imgSrc": "/assets/images/client_logos/cambridge.png", "altText": "cambridge" },
    { "imgSrc": "/assets/images/client_logos/PrincetonUniversity.png", "altText": "Princeton University" },
    { "imgSrc": "/assets/images/client_logos/biogen.png", "altText": "biogen" },
    { "imgSrc": "/assets/images/client_logos/UNSW.png", "altText": "UNSW" },
    { "imgSrc": "/assets/images/client_logos/accelera.png", "altText": "accelera" },
    { "imgSrc": "/assets/images/client_logos/pfizer.png", "altText": "pfizer" }
  ];
  
}
